import { useTranslation } from '@src/i18n';
import logomark from '../assets/icons/7shifts-logomark.svg';
import './AppFooter.css';

export function AppFooter() {
    const { t } = useTranslation();
    return (
        <footer className="app-footer">
            <img
                src={logomark}
                alt=""
                className="app-footer__logo"
                aria-hidden="true"
            />
            <span className="app-footer__text">{t('footer.poweredBy')}</span>
        </footer>
    );
}
